import React from 'react';
import { motion } from 'framer-motion';
import { CardPreview } from './CardPreview';
const rows = ['The Young Inventor Lab™ — 5 printable volumes / 120 build cards', 'The Build Path Guide', 'The Inventor Progress Tracker', 'The 7-Day Maker Kickstart', 'The Materials Swap Guide', 'Build Fix-It Cards', 'Backyard Maker Missions', '52 Weeks of Wonder'];
export function ValueStack() {
  return <section id="get-access" className="w-full scroll-mt-20 bg-white px-5 py-12 sm:py-20" data-id="element-243" data-mp="2i0k81nj0mfm4">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-[600px]" data-id="element-244" data-mp="2myvkm60p3481">
        <h2 className="text-center font-serif-display text-2xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-245" data-mp="2d6zf49wa4bts">
          Everything included in your Young Inventor Lab™
        </h2>

        <div className="mt-6 rounded-2xl border border-blue/15 p-4 sm:mt-8 sm:p-6" data-id="element-246" data-mp="35qob9tsakdcl">
          <ul data-id="element-247" data-mp="1tgehluezder3">
            {rows.map(row => <li key={row} className="flex items-center justify-between gap-3 border-b border-dashed border-blue/20 py-2 last:border-b-0 sm:py-2.5" data-id="element-248" data-mp="1oga2a7pt6q2g">
                <span className="text-[13px] text-navy/80 sm:text-sm" data-id="element-249" data-mp="236zdha39s56b">{row}</span>
                <span className="shrink-0 text-[13px] font-bold text-teal sm:text-sm" data-id="element-250" data-mp="1ycd236x6ucm8">Included</span>
              </li>)}
          </ul>

          <div className="mt-4 flex flex-col items-center rounded-xl bg-peach py-6 text-center sm:py-7" data-id="element-251" data-mp="2850y3zgcgcjw">
            <span className="text-sm font-semibold text-spark-deep" data-id="element-252" data-mp="2m4abkrd60sk6">
              Today’s complete printable library
            </span>
            <span className="font-serif-display text-5xl font-bold text-navy sm:text-6xl" data-id="element-253" data-mp="2h5qouoqqzcqr">
              $27 USD
            </span>
            <p className="mt-2 px-4 text-xs font-semibold text-navy/75 sm:text-sm" data-id="element-254" data-mp="mqwmdbrjcgcr">
              One-time payment · Instant digital access · No special kit required
            </p>
            <p className="mt-2 px-4 text-xs text-navy/60" data-id="element-255" data-mp="2mvikjuatnph7">
              Digital product only. No physical kit is shipped.
            </p>
          </div>
        </div>

        <CardPreview data-id="element-256" data-mp="2vsarrwuqjw3n" />
      </motion.div>
    </section>;
}